(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
class NewInSlider {
  constructor() {
    this.slider = document.getElementById('newInSlider');
    this.track = document.getElementById('newInTrack');
    this.progressFill = document.getElementById('progressFill');
    
    if (!this.slider || !this.track) return;
    
    this.slides = Array.from(this.track.querySelectorAll('.new-in-slide'));
    this.totalSlides = this.slides.length;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isDragging = false;
    
    this.init();
  }
  
  init() {
    this.updateProgress();
    this.attachEventListeners();
    window.addEventListener('resize', () => this.updateProgress());
  }
  
  attachEventListeners() {
    this.slider.addEventListener('scroll', () => {
      this.updateProgress();
    }, { passive: true });
    
    this.slider.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
      this.isDragging = true;
    }, false);
    
    this.slider.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.isDragging = false;
      this.handleSwipe();
    }, false);
    
    let mouseDown = false;
    let startX;
    let scrollLeft;
    
    this.slider.addEventListener('mousedown', (e) => {
      mouseDown = true;
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });
    
    this.slider.addEventListener('mouseleave', () => {
      mouseDown = false;
    });
    
    this.slider.addEventListener('mouseup', () => {
      mouseDown = false;
    });
    
    this.slider.addEventListener('mousemove', (e) => {
      if (!mouseDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 1;
      this.slider.scrollLeft = scrollLeft - walk;
    });
  }
  
  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    const threshold = 50;
    
    if (Math.abs(diff) > threshold) {
      const slideWidth = this.getSlideWidth();
      const scrollAmount = slideWidth + this.getGapWidth();
      const direction = diff > 0 ? 1 : -1;
      const targetScroll = this.slider.scrollLeft + (scrollAmount * direction);
      
      this.slider.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  }
  
  getSlideWidth() {
    if (this.slides.length === 0) return 0;
    const rect = this.slides[0].getBoundingClientRect();
    return rect.width;
  }
  
  getGapWidth() {
    if (window.innerWidth >= 750) {
      return 24;
    }
    return 16;
  }
  
  updateProgress() {
    if (!this.progressFill) return;
    
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const scrollPercentage = maxScroll > 0 ? (this.slider.scrollLeft / maxScroll) * 100 : 0;
    
    this.progressFill.style.width = Math.min(scrollPercentage, 100) + '%';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new NewInSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
